
<style scoped lang="scss">
$modal_base_width: 90vw;
$modal_max_width: 550px;
$modal_max_height: 450px;
$overlay_color: rgba(0, 0, 0, 0.5);
$font_color: #EBEBEB;

.animating-modal_wrapper {
  position: fixed;
  z-index: 100;
  // z-index: map-get($zi_map, modal);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.animating-modal_overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: $overlay_color;
  cursor: pointer;
}
.animating-modal_content {
  position: absolute;
  width: $modal_base_width;
  max-width: $modal_max_width;
  max-height: $modal_max_height;
  padding: 1rem;

  // centerize
  transform: translate(calc(50vw - 50%), calc(50vh - 50%));

  overflow: auto;

  .modal-header {
    font-size: 2rem;
    padding: 0.5rem;
    text-align: center;
    color: $font_color;
  }

  // 右上X
  .close-button {
    font-size: 1.5rem;
    color: $font_color;
    // border: solid 1px white;
    cursor: pointer;
    position: absolute;
    top: 4px;
    right: 4px;
  }
}

// y軸折りたたみ animation
.collapse-enter-active, .collapse-leave-active {
  transition: transform .1s cubic-bezier(0.39, 0.575, 0.565, 1);
  transform-origin: center;
}
.collapse-enter, .collapse-leave-to {
  transform: scaleX(0);
}
// .fade-enter-active, .fade-leave-active {
//   transition: opacity .4s;
// }
// .fade-enter, .fade-leave-to {
//   opacity: 0;
// }
</style>

<template>
<transition name="collapse">
  <div :class="wrapperClassObj" v-show="isActive">
    <div class="animating-modal_overlay" @click="onPushClose"></div>
    <div class="animating-modal_content" v-show="isActive">
      <div class="modal-header">
        <div class="close-button" @click="onPushClose">&Chi;</div>
        <h3 v-if="title">{{title}}</h3>
      </div>
      <slot></slot>
    </div>
  </div>
</transition>
</template>

<script>
export default {
  name: 'animatingModal',
  props: {
    title: String,
    isActive: {
      default: false,
      type: Boolean,
    }
  },
  computed: {
    wrapperClassObj () {
      return {
        'animating-modal_wrapper': true,
        // 'animated': true,
        // 'fadeInUp': this.isActive, // 出現
        // 'fadeOutUp': (this.isActive == false), // 消える
      };
    },
  },
  methods: {
    onPushClose () {
      this.$emit('closed');
    }
  },
  mounted () {
    // bodyがスクロールしないようにする
    this.$el.addEventListener('touchmove', function(e) {
      if (e.target.type === 'range') {
        e.stopPropagation();
      } else {
        e.preventDefault();
      }
    }, false);
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sub/AnimatingModal.vue